import LogUtil from '@/core/utils/logUtil';
import JSONUtil from '@/core/utils/jsonUtil';
import DomUtil from '@/core/utils/domUtil';
//import HelperUtil from '@/core/utils/helperUtil';
//import FeatureUtil from '@/core/utils/featureUtil';
import JSONLoader from '@/core/loader/jsonLoader';
import ViewController from '@/core/controller/viewController';
import CoreApplicationStateModel from '@/core/model/CoreApplicationStateModel';
import ViewportController from "@/core/utils/viewport/viewportController";

export default class CoreApplication {

    prepareApp(viewFactory: any) {
        let mainDomElement = document.getElementsByTagName('main')[0];
        ViewController.instance.initialize(mainDomElement, viewFactory);
    }

    loadContent() {
        LogUtil.log('loadcontent');

        let queryFile = '';//HelperUtil.getQueryString('content');
        let main = document.getElementsByTagName('main');
        let dataContentAttr = main[0].getAttributeNode('data-content');
        let fallbackFile = dataContentAttr ? dataContentAttr.value : '';
        let jsonFile = fallbackFile;

        LogUtil.log('loadfile :', fallbackFile);

        const loadDataSuccessHandler = (result: any) => {
            CoreApplicationStateModel.content = JSONUtil.replaceBasePath(result[0]);
            this.loadContentComplete();
        };

        const loadDataErrorHandler = (error: any) => {
            if (queryFile === jsonFile && fallbackFile) {
                LogUtil.error('Loading JSON Error. Loading fallback content from', fallbackFile);

                JSONLoader.loadAll([fallbackFile]).then(loadDataSuccessHandler, loadFallbackDataErrorHandler);
                return;
            }

            LogUtil.error('Loading JSON Error. Couldn´t load ', jsonFile, error);
        };

        const loadFallbackDataErrorHandler = (error: any) => {
            LogUtil.error('Loading JSON fallback Error. Couldn´t load ', fallbackFile, error);
        };

        JSONLoader.loadAll([jsonFile]).then(loadDataSuccessHandler, loadDataErrorHandler);

    }


    loadContentComplete() {
    }

    constructor() {
        let htmlElement = document.getElementsByTagName('html')[0];

        ViewportController.instance.init()

        DomUtil.removeClass(htmlElement, 'no-js');
        DomUtil.addClass(htmlElement, 'js');
        /*
         if(FeatureUtil.touchevents()) {
         DomUtil.addClass(htmlElement, 'touchevents');
         } else {
         DomUtil.addClass(htmlElement, 'no-touchevents');
         }
         */
    }

}
